import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import type {
  EmailTemplateType,
  IEmailTemplateResponse,
} from "@miplatform/types";
import { useEmailTemplate } from "@mibuildweb/hooks";

export const useOrderInfoCardEmailsViewModel = () => {
  const [emailTemplates, setEmailTemplates] = useState<
    IEmailTemplateResponse[]
  >([]);
  const { isLoading, getEmailTemplatesByOrderTemplateId } = useEmailTemplate();
  const stateManager = useComponentState();
  const [emailHistory, setEmailHistory] = useState<
    Record<string, IEmailTemplateResponse>
  >({});

  const handleGetEmailTemplateDetails = (templateId: string) => {
    getEmailTemplatesByOrderTemplateId(templateId, {
      onSuccess: setEmailTemplates,
    });
  };

  const getEmailHistory = (id: string) =>
    stateManager.run(async () => {
      const response = await taskService.order.getEmailHistory({
        orderId: id,
        toastMessageConfig: {},
      });

      if (response.status === HTTP_STATUSES.OK) {
        const recentEmails = response.data.reduce(
          (
            acc: Record<EmailTemplateType, IEmailTemplateResponse>,
            email: IEmailTemplateResponse
          ) => {
            if (
              !acc[email.emailType] ||
              new Date(email.createdOn) >
                new Date(acc[email.emailType].createdOn)
            ) {
              acc[email.emailType] = email;
            }
            return acc;
          },
          {} as Record<EmailTemplateType, IEmailTemplateResponse>
        );

        setEmailHistory(recentEmails);
      }
    });

  return {
    isLoading: isLoading || stateManager.isBusy(),
    emailHistory,
    emailTemplates,
    getEmailTemplateDetails: handleGetEmailTemplateDetails,
    getEmailHistory,
  };
};
